module.exports = __webpack_public_path__ + "static/img/icon-tip-red.cd1f80b1.svg";